import getOptionsForResourcesMultiselect from './getOptionsForResourcesMultiselect';

export default function (options, ganttId = null) {
  const resources = getOptionsForResourcesMultiselect(ganttId);

  return options.reduce((result, option) => {
    const resource = resources.find(item => (item.id === option.resource_id) || (item.userId === option.userId));

    if (resource) {
      result.push({
        ...resource,
        id: option.id,
        sort_order: option.sort_order,
      });
    }

    return result;
  }, []);
}
